import { getCurrentPath } from "@faire/web--source/common/Path";
import { ContactFormLink } from "@faire/web--source/ui/ContactFormLink";
import { trackCxFoundationsContactFormLinkRetailerWebClick } from "@faire/web-api--source/events/cxFoundations/click/contactFormLinkRetailerWeb";
import React, { type JSX } from "react";

const onContactFormClick = () =>
  trackCxFoundationsContactFormLinkRetailerWebClick(
    getCurrentPath().toString()
  );

export const LoggedOutContactFormLinkFormatting = (
  chunk: JSX.Element,
  onClick?: () => void
): JSX.Element => (
  <ContactFormLink
    loggedOut
    onClick={() => {
      onContactFormClick();
      onClick?.();
    }}
  >
    {chunk}
  </ContactFormLink>
);

export const ContactFormLinkFormatting = (chunk: JSX.Element): JSX.Element => (
  <ContactFormLink onClick={onContactFormClick}>{chunk}</ContactFormLink>
);
